import { render, staticRenderFns } from "./SAccCopyRepo.vue?vue&type=template&id=7e66d034&scoped=true"
import script from "./SAccCopyRepo.vue?vue&type=script&lang=ts"
export * from "./SAccCopyRepo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e66d034",
  null
  
)

export default component.exports